import './Select.scss';

export { default } from './Select';
